"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  delay: '0s',
  speed: '50',
  direction: 'left',
  pauseOnHover: false,
  pauseOnClick: false
};
exports["default"] = _default;